(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(52707);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50122);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _utils_getFontValue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84856);






// @mui

// utils

// ----------------------------------------------------------------------
var TextMaxLine = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var asLink = _param.asLink, _variant = _param.variant, variant = _variant === void 0 ? "body1" : _variant, _line = _param.line, line = _line === void 0 ? 2 : _line, _persistent = _param.persistent, persistent = _persistent === void 0 ? false : _persistent, children = _param.children, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "asLink",
        "variant",
        "line",
        "persistent",
        "children",
        "sx"
    ]);
    var lineHeight = (0,_utils_getFontValue__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(variant).lineHeight;
    var style = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: line,
        WebkitBoxOrient: "vertical"
    }, persistent && {
        height: lineHeight * line
    }, sx);
    if (asLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            color: "inherit",
            ref: ref,
            variant: variant,
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, style)
        }, other), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        variant: variant,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, style)
    }, other), {
        children: children
    }));
});
TextMaxLine.propTypes = {
    asLink: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node.isRequired),
    line: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().number),
    persistent: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    sx: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().object),
    variant: prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOf([
        "body1",
        "body2",
        "button",
        "caption",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "inherit",
        "overline",
        "subtitle1",
        "subtitle2", 
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (TextMaxLine);


/***/ }),

/***/ 52707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JoinTeam": function() { return /* binding */ JoinTeam; },
  "default": function() { return /* binding */ HomePage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardMedia/CardMedia.js + 1 modules
var CardMedia = __webpack_require__(83965);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./src/layouts/index.js + 21 modules
var layouts = __webpack_require__(85307);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
// EXTERNAL MODULE: ./src/components/TextMaxLine.js
var TextMaxLine = __webpack_require__(90519);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/hooks/useSettings.js
var useSettings = __webpack_require__(40571);
// EXTERNAL MODULE: ./src/assets/index.js + 16 modules
var assets = __webpack_require__(27582);
;// CONCATENATED MODULE: ./src/sections/home/Welcome.js
// @mui




//

// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        boxShadow: "none",
        textAlign: "center",
        backgroundColor: theme.palette.primary.lighter
    }, theme.breakpoints.up("md"), {
        height: "100%",
        display: "flex",
        textAlign: "left",
        alignItems: "center",
        justifyContent: "space-between"
    });
});
// ----------------------------------------------------------------------
function Welcome() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                sx: {
                    color: "grey.800",
                    p: {
                        md: 0
                    },
                    pl: {
                        md: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        gutterBottom: true,
                        variant: "h4",
                        children: [
                            "Hệ thống,",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " \xd4N THI GPLX",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "\xd4 T\xd4, XE M\xc1Y"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            pb: {
                                xs: 1,
                                xl: 2
                            },
                            maxWidth: 480,
                            mx: "auto",
                            mt: 2
                        },
                        children: "Những c\xe2u hỏi \xf4n tập v\xe0 đề thi chuẩn nhất trong th\xe1ng. Bạn c\xf3 thể tham gia ngay trong ng\xe0y h\xf4m nay..."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(assets.MotivationIllustration, {
                sx: {
                    p: 1,
                    width: 200,
                    margin: {
                        xs: "auto",
                        md: "inherit"
                    }
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/index.js
// @mui





// @mui


// components

// sections







var HomeSlider = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5080).then(__webpack_require__.bind(__webpack_require__, 45080));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45080)
            ];
        }
    }
});
var HomeMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7393).then(__webpack_require__.bind(__webpack_require__, 87393));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87393)
            ];
        }
    }
});
// ----------------------------------------------------------------------
var pages_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(15)
    });
});
HomePage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
// ----------------------------------------------------------------------
function HomePage() {
    var translate = (0,useLocales/* default */.Z)().translate;
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: translate("index.title"),
        description: translate("index.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: themeStretch ? "xl" : "lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_RootStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeMenu, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinTeam, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: {
                            my: 5
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTable, {})
                ]
            })
        })
    });
}
function BannerSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        mb: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Welcome, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSlider, {})
            })
        ]
    });
}
var JoinTeam = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        sx: {
            mt: 10,
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    mb: 2,
                    color: "text.error"
                },
                children: "HỌC L\xc1I XE TH\xc0NH C\xd4NG"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                sx: {
                    mb: 3,
                    textTransform: "capitalize"
                },
                children: "Nhận Hồ Sơ & Bổ T\xfac Tay L\xe1i"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    mx: "auto",
                    maxWidth: 630,
                    color: function(theme) {
                        return theme.palette.mode === "light" ? "text.secondary" : "common.white";
                    },
                    fontWeight: 400
                },
                children: "Nhận hồ sơ l\xe1i xe uy t\xedn, th\xe2n thiện, chi ph\xed r\xf5 r\xe0ng. Cam kết học đến khi đậu lấy bằng. Xin gọi về: 098.707.2219"
            })
        ]
    });
};
var data = [
    {
        id: 1,
        title: "Nguyễn Anh Thơ - Sinh vi\xean ngoại thương",
        description: "H\xf4m nay em nhận được bằng rồi! Thầy dạy rất c\xf3 t\xe2m v\xe0 dễ hiểu. Em c\xe1m ơn trung t\xe2m Long Bi\xean đ\xe3 gi\xfap em đạt được mục ti\xeau l\xe1i xe",
        featureImage: "/daylaixe/user-1.jpg"
    },
    {
        id: 2,
        title: "B\xe1c Ho\xe0ng - Nh\xe2n vi\xean kinh doanh",
        description: "Cảm gi\xe1c lần đầu cầm v\xf4 lăng c\xf2n run cầm cập! Vậy m\xe0 b\xe2y giờ bon bon xe tr\xean đường đi l\xe0m rồi. Thật biết ơn c\xe1c thầy v\xe0 trung t\xe2m.",
        featureImage: "/daylaixe/user-2.jpg"
    },
    {
        id: 3,
        title: "Phạm Đ\xecnh Phương - Nh\xe2n vi\xean văn ph\xf2ng",
        description: "M\xecnh bị trượt thực h\xe0nh nhưng được c\xe1c thầy tận t\xe2m chỉ dạy lại chi tiết từng b\xe0i thi v\xe0 lỗi sai. Rất biết ơn c\xe1c thầy!",
        featureImage: "/daylaixe/user-3.jpg"
    },
    {
        id: 4,
        title: "Nguyễn Anh Qu\xe2n - Sinh vi\xean học viện KMA",
        description: "Học l\xe1i xe nh\xecn dễ m\xe0 kh\xf3 c\xe1c bạn ạ. M\xecnh cũng bị t\xe2m l\xfd may m\xe0 được c\xe1c thầy trấn an v\xe0 luyện tập nhiều n\xean giờ l\xe1i xe tốt rồi!",
        featureImage: "/daylaixe/user-4.jpg"
    }, 
];
var Reviews = function() {
    var settings = {
        speed: 1500,
        dots: true,
        arrows: false,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h3",
                    sx: {
                        color: "text.error",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: 25,
                            height: 25,
                            icon: "mdi:heart",
                            sx: {
                                color: "red"
                            }
                        }),
                        " Cảm nhận học vi\xean ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: 25,
                            height: 25,
                            icon: "mdi:heart",
                            sx: {
                                color: "red"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                    children: data.map(function(item) {
                        var displayName = item.displayName, title = item.title, description = item.description, featureImage = item.featureImage;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                px: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia/* default */.Z, {
                                        component: "img",
                                        height: "194",
                                        image: featureImage,
                                        alt: displayName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                gutterBottom: true,
                                                variant: "subtitle2",
                                                sx: {
                                                    textTransform: "uppercase"
                                                },
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextMaxLine/* default */.Z, {
                                                variant: "body2",
                                                line: 3,
                                                persistent: true,
                                                children: description
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, item.id);
                    })
                }))
            })
        ]
    });
};
var PriceTable = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        sx: {
            mt: 10,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            spacing: 5,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h4",
                    children: "BẢNG GI\xc1 TRỌN G\xd3I"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia/* default */.Z, {
                        component: "img",
                        image: "/daylaixe/bang-gia.jpg",
                        alt: "Dạy l\xe1i xe"
                    })
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,1160,6093,5530,3559,7582,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);